import { createLocalMarker } from './local-marker'

export const ACCESS_RETRY_STORAGE_KEY = 'institutional-access-retry'

/**
 * A registration whose access request never landed leaves the account with no
 * institutional record at all - invisible to review and to the user. This marker lets
 * the next authenticated session finish the job.
 */
const marker = createLocalMarker({
  key: ACCESS_RETRY_STORAGE_KEY,
  maxAttempts: 5,
  maxAgeMs: 7 * 24 * 60 * 60 * 1000
})

export const readInstitutionalAccessRetry = marker.read
export const storeInstitutionalAccessRetry = marker.store
export const clearInstitutionalAccessRetry = marker.clear
